import { render, staticRenderFns } from "./BatchLogMessagesDialog.vue?vue&type=template&id=72b9d757&scoped=true&"
import script from "./BatchLogMessagesDialog.vue?vue&type=script&lang=js&"
export * from "./BatchLogMessagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchLogMessagesDialog.vue?vue&type=style&index=0&id=72b9d757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9d757",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b9d757')) {
      api.createRecord('72b9d757', component.options)
    } else {
      api.reload('72b9d757', component.options)
    }
    module.hot.accept("./BatchLogMessagesDialog.vue?vue&type=template&id=72b9d757&scoped=true&", function () {
      api.rerender('72b9d757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoicing/Dialogs/BatchLogMessagesDialog.vue"
export default component.exports